<template>
	<div class="has-background-svg is-fullheight">
		<the-navigation />
		<div class="section">
			<div class="container">
				<router-view />
			</div>
		</div>
		<footer class="footer">
			<div class="content has-text-centered">
				<!-- eslint-disable-next-line vue/no-v-html -->
				<p v-html="$t('html.footer')" />
			</div>
		</footer>
		<the-modals class="is-abs" />
		<dp-screen-cover v-if="busy" :value="$t('title.busy')" />
	</div>
</template>

<script>
import { always, tryCatch } from 'ramda';
import TheNavigation from './components/the-navigation';
import TheModals from './components/the-modals';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
	components: { TheNavigation, TheModals },
	props: {
		locale: { type: String, default: 'en' },
		data: { type: String, default: null },
		id: { type: Number, default: null },
	},
	data: () => ({ updatingData: false }),
	computed: {
		...mapState(['busy', 'selectedId']),
		...mapGetters(['stateData', 'characters', 'canAddCharacter', 'canRemoveCharacter']),
		unsupportedLocale() { return !this.$i18n.messages[this.locale]; },
	},
	watch: {
		locale(locale) { this.$i18n.locale = locale; },
		stateData(data) { return this.publishState({ data }); },
		selectedId(id) { return this.publishState({ id }); },
		data(data) {
			if (this.updatingData) { return; }
			this.setStateData(data);
		},
		id(id) {
			if (this.updatingData) { return; }
			this.selectId(id);
		},
	},
	mounted() {
		if (this.unsupportedLocale) { return this.resetLocale(); }
		this.$i18n.locale = this.locale;
		const { id, data } = this.restoreRoute();
		this.setStateData(this.data || data);
		this.selectId(this.id || id);
		return this.publishState();
	},
	methods: {
		...mapActions(['setStateData', 'selectId']),
		backupRoute(data) {
			this._setItem('currentRoute', JSON.stringify(data));
		},
		restoreRoute() {
			const tryParse = key => JSON.parse(this._getItem(key));
			return tryCatch(tryParse, always({}))('currentRoute') || {};
		},
		resetLocale() {
			this.$router.replace({ params: { locale: 'en' } });
		},
		async publishState({ id = this.selectedId, data = this.stateData } = {}) {
			if (this.isActiveRoute({ id, data })) { return; }
			this.updatingData = true;
			this.backupRoute({ id, data });
			try { await this.$router.push({ params: { id }, query: { data } }); }
			finally { this.updatingData = false; }
		},
		isActiveRoute({ id, data }) {
			const { query, params } = this.$route;
			return query.data === data && String(params.id) === String(id);
		},
		_getItem(key) { return localStorage.getItem(key); },
		_setItem(key, value) { return localStorage.setItem(key, value); },
	},
};
</script>
